const navScrollHighlight = {

	ui: {},

	sectionIdToNavigationLink: {},

	trackIsAnimating: false,

	init: function() {
		this.bindUI();
		this.bindEvents();

        this.ui.$navSections.each(function() {
			navScrollHighlight.sectionIdToNavigationLink[$(this).attr('id')] = $(".js-nav-link[href='#" + $(this).attr('id') + "']");
        });

		this.updateNavHighlight();
	},
	
	bindUI: function() {
		this.ui.$window = $(window);
		this.ui.$document = $(document);
		
		this.ui.$navigationLinks = $(".js-nav-link");
		this.ui.$navSections = $(".js-nav-section");
		this.ui.$navSectionsReversed = $(this.ui.$navSections.get().reverse());
	},

	bindEvents: function() {
		this.ui.$window.on('scroll', this.updateNavHighlight.bind(this));
		this.ui.$navigationLinks.on('click', this.scrollToSection.bind(this));
	},

    get_adminBarHeight: function() {
		let admin_bar_height = getComputedStyle(document.documentElement).getPropertyValue('--wp-admin--admin-bar--height');
		return parseInt(admin_bar_height.replace('px', ''));
	},

    updateNavHighlight: function() {
        let scrollPosition = this.ui.$window.scrollTop();

        let addToInitialOffset;
        if (window.innerWidth <= 1024) {
            addToInitialOffset = 90;
        } else {
			addToInitialOffset = 90;
		}
		if ($('body').hasClass('admin-bar')) {
			addToInitialOffset += this.get_adminBarHeight();
		}
        addToInitialOffset += 140;

        this.ui.$navSectionsReversed.each((index, element) => {
            let $currentSection = $(element);
            let sectionTop = $currentSection.offset().top - addToInitialOffset;

            if (scrollPosition >= sectionTop) {
                let id = $currentSection.attr('id');
                let $navigationLink = this.sectionIdToNavigationLink[id];
                if (!$navigationLink.hasClass('active')) {
					this.ui.$navigationLinks.removeClass('active');
                    $navigationLink.addClass('active');
					this.centerHorizontalNav();
                }

                return false;
            }
        });
    },

	centerHorizontalNav: function() {
		if (window.innerWidth > 1024) {
			return false;
		}

		let $activeNavLink = $('.js-nav-link.active');
		if ($activeNavLink.length) {
			let $track = $activeNavLink.closest('.js-offerNav-inner');
			let activeWidthCenter = $activeNavLink.width()/2;
			let pos = $activeNavLink.position().left + activeWidthCenter;
			let currentScroll = $track.scrollLeft();
			let divWidth = $track.width();
			pos = pos + currentScroll - divWidth / 2;
			$track.scrollLeft(pos);
		}
	},

	scrollToSection: function(e) {
		let $this = $(e.currentTarget);
		e.preventDefault();

		let addToInitialOffset;
		if (this.ui.$window.width() <= 1024) {
			addToInitialOffset = 100;
		} else {
			addToInitialOffset = 100;
		}
		if ($('body').hasClass('admin-bar')) {
			addToInitialOffset += this.get_adminBarHeight();
		}

		$('html, body').animate({
			scrollTop: $($this.attr('href')).offset().top - addToInitialOffset
		}, 300);
	},

};

export default navScrollHighlight;
